import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getAccountCustomFieldByAccountIdandAccountCustomFieldIdAsync, deleteAccountCustomFieldAsync, checkedState, unCheckedState, checkedAllState, updateSorting, unCheckedAllState, getDataByMasterEntityTypeIdAsync } from './CustomFieldSlice';
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';
import clsx from 'clsx';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { useLocation } from 'react-router-dom';

const CustomFieldManageItem = (props: any) => {
    const { customFieldList, t, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.customField);
    const dispatch = useAppDispatch();
        const location = useLocation();
        const params = new URLSearchParams(location.search);
        const MasterEntityTypeId = params.get('MasterEntityTypeId');

    const onDeleteClick = (obj: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountCustomFieldAsync(obj));
                }
                dispatch(getDataByMasterEntityTypeIdAsync(MasterEntityTypeId));
            }).catch(() => {});
    }

    const onEditClick = (AccountCustomFieldId: string) => {
        dispatch(getAccountCustomFieldByAccountIdandAccountCustomFieldIdAsync(AccountCustomFieldId));
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

return (
    <>
        {customFieldList && customFieldList.length > 0 ? (
            <table className="table table-row-bordered align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={customFieldList.every((item: any) => item.isSelected === 0) ? false :
                                            (customFieldList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        {IsEdit &&
                            <th style={{width:'15%'}}>
                                {getValueFromResource('Active / Inactive', dispatch, t)}
                                {sortColumn === 'IsDisabled' ?
                                    sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                    </span>
                                :
                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                        <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                    </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                    </span></>
                                }
                            </th>
                        }
                        <th style={{width:'15%'}}>
                            {getValueFromResource('Custom Field Name', dispatch, t)}
                            {sortColumn === 'CustomFieldName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CustomFieldName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CustomFieldName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                            :
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CustomFieldName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                </span>
                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CustomFieldName") }}>
                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                </span></>
                            }
                        </th>
                        <th style={{width:'15%'}}>
                            {getValueFromResource('Master Custom Data Type Name', dispatch, t)}
                            {sortColumn === 'MasterCustomDataTypeId' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MasterCustomDataTypeId") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MasterCustomDataTypeId") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                            :
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "MasterCustomDataTypeId") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                </span>
                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "MasterCustomDataTypeId") }}>
                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                </span></>
                            }
                        </th>
                        <th style={{width:'15%'}}>
                            {getValueFromResource('Custom Field Caption', dispatch, t)}
                            {sortColumn === 'CustomFieldCaption' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CustomFieldCaption") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CustomFieldCaption") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                            :
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CustomFieldCaption") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                </span>
                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CustomFieldCaption") }}>
                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                </span></>
                            }
                        </th>
                        <th style={{width:'15%'}}>
                            {getValueFromResource('Default Value', dispatch, t)}
                            {sortColumn === 'DefaultValue' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "DefaultValue") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "DefaultValue") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                            :
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "DefaultValue") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                </span>
                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "DefaultValue") }}>
                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                </span></>
                            }
                        </th>
                        <th style={{width:'8%'}}>
                            {getValueFromResource('Is Required', dispatch, t)}
                            {sortColumn === 'IsRequired' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsRequired") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsRequired") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                            :
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsRequired") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                </span>
                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsRequired") }}>
                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                </span></>
                            }
                        </th>
                        <th className='text-end'></th>
                    </tr>
                </thead>
                <tbody>
                    {customFieldList.map((customFieldDetails: any) =>
                        <tr key={customFieldDetails.AccountCustomFieldId}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={customFieldDetails.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, customFieldDetails.AccountCustomFieldId) }}
                                        />
                                    </div>
                                </td>
                            }
                            {IsEdit &&
                                <td>
                                    <div className="form-check form-switch form-check-custom">
                                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(customFieldDetails.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                            {customFieldDetails.IsDisabled === 'No' ? "Active" : "InActive"}
                                        </span>
                                    </div>
                                </td>
                            }
                          
                            <td id={`${IsEdit ? 'kt_OffCanvas' : ''}`} className='text-gray-800 text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(customFieldDetails.AccountCustomFieldId) : undefined}
                            >
                                <span className="d-block">{customFieldDetails.CustomFieldName}</span>
                            </td>
                            <td>
                                <span className="d-block">{customFieldDetails.MasterCustomDataTypeName}</span>
                            </td>
                            <td>
                                <span className="d-block">{customFieldDetails.CustomFieldCaption}</span>
                            </td>
                            <td>
                                <span className="d-block">{customFieldDetails.DefaultValue}</span>
                            </td>
                            <td>
                                <span className="d-block">{customFieldDetails.IsRequired}</span>
                            </td>
                        
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item
                                                    id="kt_OffCanvas"
                                                    className="menu-item me-lg-0 "
                                                    onClick={() => { onEditClick(customFieldDetails.AccountCustomFieldId) }}
                                                >
                                                    <span className="menu-icon custom-menu"><i className="bi bi-pencil-square fs-6 iconColor allign"></i></span>
                                                    <span className="menu-title custom-menu-fontsize">{getValueFromResource('Edit', dispatch, t)}</span>
                                                </Dropdown.Item>
                                            </div>
                                        }
                                        {IsDelete && IsEdit && <div className='separator mb-1 mt-1 opacity-75 '></div>}
                                        {IsDelete &&
                                            <div className='menu-hover-bg-danger'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0 "
                                                    onClick={() => { onDeleteClick(customFieldDetails.AccountCustomFieldId) }}>
                                                    <span className="menu-icon custom-menu"><i className="bi bi-trash fs-6 delete-menu-icon-color allign" ></i></span>
                                                    <span className="menu-title delete-menu custom-menu-fontsize">{getValueFromResource('Delete', dispatch, t)}</span>
                                                </Dropdown.Item>
                                            </div>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        ) : (
            <div className=''>
                <p className='noDataFound'>
                    {getValueFromResource('No Record Found', dispatch, t)}
                </p>
            </div>
        )}
    </>
)
}
export default CustomFieldManageItem;



